module.exports = __webpack_public_path__ + "817569056395e9c59a89e0350451c437.pdf";